import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, MapPin } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Beranda', href: '#beranda' },
    { name: 'Menu', href: '#menu' },
    { name: 'Tentang', href: '#tentang' },
    { name: 'Ulasan', href: '#ulasan' },
    { name: 'Kontak', href: '#kontak' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <a
              href="#beranda"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('#beranda');
              }}
              className="flex items-center gap-3"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-amber-600 to-red-700 rounded-full flex items-center justify-center shadow-lg">
                <span className="text-white font-bold text-lg">AC</span>
              </div>
              <div className={`hidden sm:block ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                <span className="font-serif font-bold text-xl">Aroma Cempaka</span>
                <span className="block text-xs opacity-80">Masakan Padang</span>
              </div>
            </a>
          </div>

          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.href);
                }}
                className={`font-medium transition-colors hover:text-amber-600 ${
                  scrolled ? 'text-gray-700' : 'text-white/90 hover:text-white'
                }`}
              >
                {link.name}
              </a>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:+6285169986774"
              className={`flex items-center gap-2 font-medium ${
                scrolled ? 'text-gray-700' : 'text-white/90'
              }`}
            >
              <Phone className="w-4 h-4" />
              <span className="hidden xl:inline">0851-6998-6774</span>
            </a>
            <Button
              onClick={() => scrollToSection('#kontak')}
              className="bg-gradient-to-r from-amber-600 to-red-700 hover:from-amber-700 hover:to-red-800 text-white shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <MapPin className="w-4 h-4 mr-2" />
              Petunjuk Arah
            </Button>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className={`lg:hidden p-2 rounded-lg ${scrolled ? 'text-gray-900' : 'text-white'}`}
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      <div
        className={`lg:hidden transition-all duration-300 overflow-hidden ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-white shadow-lg px-4 py-6 space-y-4">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(link.href);
              }}
              className="block py-2 text-gray-700 font-medium hover:text-amber-600 transition-colors"
            >
              {link.name}
            </a>
          ))}
          <div className="pt-4 border-t border-gray-100 space-y-3">
            <a
              href="tel:+6285169986774"
              className="flex items-center gap-2 text-gray-700"
            >
              <Phone className="w-4 h-4" />
              0851-6998-6774
            </a>
            <Button
              onClick={() => scrollToSection('#kontak')}
              className="w-full bg-gradient-to-r from-amber-600 to-red-700 text-white"
            >
              <MapPin className="w-4 h-4 mr-2" />
              Petunjuk Arah
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
